import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Renderads from './advertisement';
import SupportCard from './SupportCard';
import FlightLoadingScreen from './FlightLoadingScreen';
import { FaPhoneAlt, FaShip, FaClock, FaHeadset, FaTag } from 'react-icons/fa';

const CruiseContactCard = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 800);
  }, []);

  if (loading) {
    return <FlightLoadingScreen />;
  }

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-blue-50 via-[#F5FFFA] to-blue-100">
      
      {/* Top Banner Ads */}
      <div className="w-full">
        <Renderads imgNumber={1} />
      </div>

      {/* Desktop Support Card */}
      <div className="hidden md:block mt-4 mb-10 px-4">
        <SupportCard />
      </div>

     
    

    </div>
  );
};

export default CruiseContactCard;
